<!-- 
https://developers.google.com/identity/oauth2/web/reference/js-reference 
https://console.cloud.google.com/apis/credentials?authuser=4&project=rankcaddy
https://developers.google.com/identity/oauth2/web/guides/migration-to-gis#authorization_code_flow_examples
-->
<template>

	<div :class="{'google-connect': true, reconnecting: reconnecting}">

		<div :class="{addGSC: true, confirmUnder: confirmUnder}">

			<svg data-v-13122b9c="" viewBox="0 0 74 24"><g data-v-13122b9c="" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g data-v-13122b9c="" fill-rule="nonzero"><g data-v-13122b9c=""><path data-v-13122b9c="" d="M0.123529412,9.28235294 C0.123529412,4.18235294 4.41176471,0.0176470588 9.52941176,0.0176470588 C12.3529412,0.0176470588 14.3647059,1.12941176 15.8823529,2.57647059 L14.1,4.35882353 C13.0235294,3.33529412 11.5411765,2.55882353 9.52941176,2.55882353 C5.80588235,2.55882353 2.89411765,5.55882353 2.89411765,9.28235294 C2.89411765,13.0058824 5.80588235,16.0058824 9.52941176,16.0058824 C11.9470588,16.0058824 13.3235294,15.0352941 14.2058824,14.1529412 C14.9294118,13.4294118 15.4058824,12.3882353 15.5823529,10.9764706 L9.52941176,10.9764706 L9.52941176,8.45294118 L18.0529412,8.45294118 C18.1411765,8.91176471 18.1941176,9.44117647 18.1941176,10.0411765 C18.1941176,11.9470588 17.6823529,14.2941176 16.0058824,15.9529412 C14.3823529,17.6470588 12.3,18.5470588 9.54705882,18.5470588 C4.41176471,18.5294118 0.123529412,14.3823529 0.123529412,9.28235294 Z" id="Shape" fill="#4285F4"></path><path data-v-13122b9c="" d="M25.0588235,6.61764706 C21.7588235,6.61764706 19.0764706,9.12352941 19.0764706,12.5823529 C19.0764706,16.0235294 21.7588235,18.5470588 25.0588235,18.5470588 C28.3588235,18.5470588 31.0411765,16.0235294 31.0411765,12.5823529 C31.0411765,9.12352941 28.3588235,6.61764706 25.0588235,6.61764706 Z M25.0588235,16.1823529 C23.2588235,16.1823529 21.6882353,14.7 21.6882353,12.5647059 C21.6882353,10.4117647 23.2411765,8.94705882 25.0588235,8.94705882 C26.8588235,8.94705882 28.4294118,10.4117647 28.4294118,12.5647059 C28.4294118,14.7 26.8588235,16.1823529 25.0588235,16.1823529 Z" id="Shape" fill="#DB4437"></path><path data-v-13122b9c="" d="M38.1176471,6.61764706 C34.8176471,6.61764706 32.1352941,9.12352941 32.1352941,12.5823529 C32.1352941,16.0235294 34.8176471,18.5470588 38.1176471,18.5470588 C41.4176471,18.5470588 44.1,16.0235294 44.1,12.5823529 C44.1,9.12352941 41.4176471,6.61764706 38.1176471,6.61764706 Z M38.1176471,16.1823529 C36.3176471,16.1823529 34.7470588,14.7 34.7470588,12.5647059 C34.7470588,10.4117647 36.3,8.94705882 38.1176471,8.94705882 C39.9352941,8.94705882 41.4882353,10.4117647 41.4882353,12.5647059 C41.4882353,14.7 39.9176471,16.1823529 38.1176471,16.1823529 Z" id="Shape" fill="#F4B400"></path><path data-v-13122b9c="" d="M54.1411765,6.97058824 L54.1411765,7.94117647 L54.0529412,7.94117647 C53.4705882,7.23529412 52.3411765,6.6 50.9117647,6.6 C47.9294118,6.6 45.1941176,9.21176471 45.1941176,12.5823529 C45.1941176,15.9176471 47.9294118,18.5294118 50.9117647,18.5294118 C52.3411765,18.5294118 53.4705882,17.8941176 54.0529412,17.1705882 L54.1411765,17.1705882 L54.1411765,18.0352941 C54.1411765,20.3117647 52.9235294,21.5294118 50.9647059,21.5294118 C49.3588235,21.5294118 48.3705882,20.3823529 47.9647059,19.4117647 L45.6882353,20.3647059 C46.3411765,21.9529412 48.0882353,23.8941176 50.9823529,23.8941176 C54.0529412,23.8941176 56.6470588,22.0941176 56.6470588,17.6823529 L56.6470588,6.97058824 L54.1411765,6.97058824 Z M51.1411765,16.1823529 C49.3411765,16.1823529 47.8235294,14.6647059 47.8235294,12.5823529 C47.8235294,10.4823529 49.3411765,8.94705882 51.1411765,8.94705882 C52.9235294,8.94705882 54.3176471,10.4823529 54.3176471,12.5823529 C54.3352941,14.6823529 52.9235294,16.1823529 51.1411765,16.1823529 Z" id="Shape" fill="#4285F4"></path><rect data-v-13122b9c="" id="Rectangle-path" fill="#0F9D58" x="58.4470588" y="0.652941176" width="2.61176471" height="17.5235294"></rect><path data-v-13122b9c="" d="M68.2411765,16.1823529 C66.9,16.1823529 65.9647059,15.5647059 65.3470588,14.3823529 L73.3235294,11.0823529 L73.0588235,10.4117647 C72.5647059,9.07058824 71.0470588,6.61764706 67.9588235,6.61764706 C64.8882353,6.61764706 62.3294118,9.03529412 62.3294118,12.5823529 C62.3294118,15.9176471 64.8529412,18.5470588 68.2411765,18.5470588 C70.9764706,18.5470588 72.5470588,16.8705882 73.2176471,15.9 L71.1882353,14.5411765 C70.5,15.5294118 69.5823529,16.1823529 68.2411765,16.1823529 Z M68.0470588,8.91176471 C69.0882353,8.91176471 69.9705882,9.42352941 70.2529412,10.1823529 L64.9235294,12.3882353 C64.8529412,10.0941176 66.7058824,8.91176471 68.0470588,8.91176471 Z" id="Shape" fill="#DB4437"></path></g></g></g></svg>

		</div>

		<p v-if="googleAccountsList.length>0&&!reconnecting&&!googleAccount&&!isShared">Select a google account that is already connected or click the Connect button to add a new one.</p>

		<p v-if="googleAccountsList.length>0&&!reconnecting&&!googleAccount&&isShared">Select a google account that is already connected to the project owners account, if the account you need is not available please ask the project owner to add it.</p>

		<p v-if="googleAccountsList.length>0&&!reconnecting&&googleAccount">Please select the relevant info from the dropdown(s) to connect your analytics account.</p>

		<p v-if="reconnecting&&!gscDone">Click the button below to reconnect your account (please make sure you select the same account if you have multiple Google accounts)</p>
		<p v-if="reconnecting&&gscDone">Your Google Account has been reconnected successfully</p>

		<v-select 
			placeholder="Select an already connected account from here"
            v-model="googleAccount" 
            :options="googleAccounts" 
            :reduce="option => option._id" 
            v-if="googleAccountsList.length>0&&!reconnecting"
        />

		<p v-if="googleAccountsList.length===0&&!reconnecting&&!isShared">Click the button below to connect us to your Google account so we can access your search console data</p>

		<p v-if="googleAccountsList.length===0&&!reconnecting&&isShared">
			<span v-if="googleAccountsList.length>0">Please select a Google Account from the dropdown below (please contact the project owner if you need another adding)</span>
			<span v-if="googleAccountsList.length===0">There are no Google Accounts available for this project, please contact the project owner as they will need to add them.</span>
		</p>

        <p :class="{response:true,error:responseType==='error'}" v-if="!!response" v-html="response" />

		<span 
			class="large-button" 
			@click="googleAuth()" 
			v-html="connectGoogleButton"
			v-if="analyticsAccountsProcessed.length===0&&!gscDone&&googleAccount!==null&&responseType!=='error'&&!!connectGoogleButton"
		/>

		<div 
			class="google-btn"
			@click="googleAuth()" 
			v-if="googleAccount===null&&!isShared"
		>

			<span class="label" v-html="connectGoogleButton" />

			<span class="google-btn-wrap">
			
				<svg width="46px" height="46px" viewBox="0 0 46 46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">
				    <!-- Generator: Sketch 3.3.3 (12081) - http://www.bohemiancoding.com/sketch -->
				    <title>btn_google_light_normal_ios</title>
				    <desc>Created with Sketch.</desc>
				    <defs>
				        <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-1">
				            <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
				            <feGaussianBlur stdDeviation="0.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
				            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.168 0" in="shadowBlurOuter1" type="matrix" result="shadowMatrixOuter1"></feColorMatrix>
				            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter2"></feOffset>
				            <feGaussianBlur stdDeviation="0.5" in="shadowOffsetOuter2" result="shadowBlurOuter2"></feGaussianBlur>
				            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.084 0" in="shadowBlurOuter2" type="matrix" result="shadowMatrixOuter2"></feColorMatrix>
				            <feMerge>
				                <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
				                <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
				                <feMergeNode in="SourceGraphic"></feMergeNode>
				            </feMerge>
				        </filter>
				        <rect id="path-2" x="0" y="0" width="40" height="40" rx="2"></rect>
				    </defs>
				    <g id="Google-Button" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
				        <g id="9-PATCH" sketch:type="MSArtboardGroup" transform="translate(-608.000000, -160.000000)"></g>
				        <g id="btn_google_light_normal" sketch:type="MSArtboardGroup" transform="translate(-1.000000, -1.000000)">
				            <g id="button" sketch:type="MSLayerGroup" transform="translate(4.000000, 4.000000)" filter="url(#filter-1)">
				                <g id="button-bg">
				                    <use fill="#FFFFFF" fill-rule="evenodd" sketch:type="MSShapeGroup" xlink:href="#path-2"></use>
				                    <use fill="none" xlink:href="#path-2"></use>
				                    <use fill="none" xlink:href="#path-2"></use>
				                    <use fill="none" xlink:href="#path-2"></use>
				                </g>
				            </g>
				            <g id="logo_googleg_48dp" sketch:type="MSLayerGroup" transform="translate(15.000000, 15.000000)">
				                <path d="M17.64,9.20454545 C17.64,8.56636364 17.5827273,7.95272727 17.4763636,7.36363636 L9,7.36363636 L9,10.845 L13.8436364,10.845 C13.635,11.97 13.0009091,12.9231818 12.0477273,13.5613636 L12.0477273,15.8195455 L14.9563636,15.8195455 C16.6581818,14.2527273 17.64,11.9454545 17.64,9.20454545 L17.64,9.20454545 Z" id="Shape" fill="#4285F4" sketch:type="MSShapeGroup"></path>
				                <path d="M9,18 C11.43,18 13.4672727,17.1940909 14.9563636,15.8195455 L12.0477273,13.5613636 C11.2418182,14.1013636 10.2109091,14.4204545 9,14.4204545 C6.65590909,14.4204545 4.67181818,12.8372727 3.96409091,10.71 L0.957272727,10.71 L0.957272727,13.0418182 C2.43818182,15.9831818 5.48181818,18 9,18 L9,18 Z" id="Shape" fill="#34A853" sketch:type="MSShapeGroup"></path>
				                <path d="M3.96409091,10.71 C3.78409091,10.17 3.68181818,9.59318182 3.68181818,9 C3.68181818,8.40681818 3.78409091,7.83 3.96409091,7.29 L3.96409091,4.95818182 L0.957272727,4.95818182 C0.347727273,6.17318182 0,7.54772727 0,9 C0,10.4522727 0.347727273,11.8268182 0.957272727,13.0418182 L3.96409091,10.71 L3.96409091,10.71 Z" id="Shape" fill="#FBBC05" sketch:type="MSShapeGroup"></path>
				                <path d="M9,3.57954545 C10.3213636,3.57954545 11.5077273,4.03363636 12.4404545,4.92545455 L15.0218182,2.34409091 C13.4631818,0.891818182 11.4259091,0 9,0 C5.48181818,0 2.43818182,2.01681818 0.957272727,4.95818182 L3.96409091,7.29 C4.67181818,5.16272727 6.65590909,3.57954545 9,3.57954545 L9,3.57954545 Z" id="Shape" fill="#EA4335" sketch:type="MSShapeGroup"></path>
				                <path d="M0,0 L18,0 L18,18 L0,18 L0,0 Z" id="Shape" sketch:type="MSShapeGroup"></path>
				            </g>
				            <g id="handles_square" sketch:type="MSLayerGroup"></g>
				        </g>
				    </g>
				</svg>

				<span class="label">Connect</span>

			</span>

		</div>

		<div :class="{'select-wraps':true}">

			<div class="select-wrap">

				<v-select 
					placeholder="Select an analytics account"
					v-model="analyticsAccount" 
					:options="analyticsAccountsProcessed" 
					v-if="googleAccount!==null&&responseType!=='error'"
				/>

			</div>
			<div class="select-wrap">

				<v-select 
					placeholder="Select an analytics property"
					v-model="webProperty" 
					:options="webProperties" 
					v-if="webProperties.length>0"
				/>

			</div>

		</div>

        <p class="connect-issue" v-if="analyticsAccount !== null && typeof analyticsAccount._id !== 'undefined' && webProperties.length===0">
        	We can't find any analytics properties in your {{analyticsAccount.label}} account?
        </p>

		<div class="buttons">

			<span 
				class="large-button mini" 
				@click="clear" 
				v-html="'Clear'"
				v-if="showSaveButton"
			/>

			<span 
				class="large-button" 
				@click="saveAnalytics" 
				v-html="'Save'"
				v-if="showSaveButton&&(reconnecting||reconnectErrored)"
			/>

		</div>

		<Loading v-if="loading!=='' && showLoading" position="inner" :text="loading" />

		<p class="statement">We will use the data from <span v-if="isShared">their</span><span v-if="!isShared">your</span> Google Analytics &amp; Search Console Accounts to display and merge data in RankCaddy's Data Dive feature. This feature will enable you to view, filter and find potential quick wins within <span v-if="isShared">their</span><span v-if="!isShared">your</span> data. Only <span v-if="isShared">their</span><span v-if="!isShared">your</span> RankCaddy account (or accounts <span v-if="isShared">they</span><span v-if="!isShared">you</span> have shared it with) will be able to view the data associated with your Google account.</p>

	</div>

</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
import ApiService from './../services/api.service'
import Loading from './Loading.vue'
import general from './../utils/general'

export default {
	name: 'GoogleConnect',
	components: {Loading},
	props: {
		projectIds: {
			type: Array,
			default: function () { return []; }
		},
		domain: {
			type: String
		},
		confirmUnder: {
			type: Boolean,
			default: false
		},
		showLoading: {
			type: Boolean,
			default: false
		},
		reconnectId: {
			type: String,
			default: ''
		},
		reconnectErrored: {
			type: Boolean,
			default: false
		},
		scope: {
			type: String,
			default: ''
		},
		clientId: {
			type: String,
			default: ''
		}
	},
	watch: {
		analyticsViewId: function (newValue, oldValue) {

			if ( newValue !== oldValue && !this.reconnecting && !this.reconnectErrored ) {

				this.complete( !!this.analyticsViewId ? 'success' : 'clear', null, { googleAccount: this.googleAccount, analyticsViewId: this.analyticsViewId } );

			}

		},
		showSaveButton: function (newValue) {

			this.$emit( 'showingSaveButton', newValue );

		},
		loading: function (newValue) {

			this.$emit( 'loading', newValue );

		},
		analyticsAccount: function (newValue, oldValue) {

			if ( newValue !== oldValue ) {
			
				this.webProperty = null;

			}

		},
		googleAccount: function (newValue, oldValue) {

			if ( newValue !== oldValue ) {

				this.analyticsAccount = null;
				if ( !newValue ) this.gscDone = false;

				this.responseType = 'success';
				this.response = '';

				if ( newValue ) {

					this.checkDomain ();

				}

			}

		}
	},
	data() {

		return {
			googleAccount: null,
			gscDone: false,
			timer: null,
			messageExtra: ['',' &nbsp; Still going!',' &nbsp; We haven\'t forgotten about you!'],
			messageExtraCurrent: 0,
			googleAccountsList: [],
			loading: '',
			analyticsAccounts: {},
			analyticsAccount: null,
			webProperty: null,
			profile: null,
			loaded: false,
			response: '',
			responseType: 'success',
			analyticsAccountsProcessed: [],
			domainsChecked: {}
		}
	},
	computed: { 

		...mapState('general',['userInfo']),
		isShared() {

			return !!this.userInfo.isShared;

		},

		showSaveButton () {

			return !!this.analyticsViewId;

		},

		reconnecting () {

			return this.reconnectId !== '';

		},

		webProperties () {

			if ( this.analyticsAccount !== null ) {

				return this.analyticsAccount.webProperties;

			}

			return [];

		},

		connectGoogleButton () {

			if ( this.reconnecting ) {

				return 'Reconnect <br />Analytics &amp; GSC';

			}

			if ( this.googleAccount !== null ) {

				return '';
				return 'Connect This Account';

			}

			return 'Connect A New Google Analytics <br />&amp; Search Console Account';

		},

		googleAccounts () {

			let accounts = [];

			this.googleAccountsList.forEach( function ( acc ) {

				accounts.push( { _id: acc._id.toString(), label: acc.email } );

			});

			return accounts;

		},

		analyticsViewId () {

			return this.webProperty !== null ? this.webProperty._id : '';

		}

    },

	methods: {

		...mapMutations('general',['updateLoadingText']),
		...mapActions('general',['loadProjects']),

		complete(status,msg,extra) {

			this.response = msg;

			let info = { status: status, msg: msg };

			if ( typeof extra !== 'undefined' ) info.extra = extra;

			if ( status && ( status === 'success' || status === 'clear' ) ) {

				this.$emit( 'complete', info );
				
			}

		},

		clear() {

			this.googleAccount = null;
			this.analyticsAccount = null;
			this.webProperty = null;
			this.profile = null;
			this.complete( 'clear', null, null );

		},

		saveAnalytics () {

			this.loading = "One moment...";
			this.response = '';

			let settings = { 
				profile: this.analyticsViewId, 
				projectIds: this.projectIds,
				type: this.webProperty.type
			}

			if ( this.googleAccount ) {

				settings.googleAccountId = this.googleAccount;

			}

			ApiService.post( 'google/saveAnalytics', settings )
			.then( function() {

				let m = this.reconnectErrored ? "Your Google account has been connected" : "Your Google account has been added";

				this.complete('success', m, this.googleAccountsList );
				this.gscDone = true;
				this.loading = "";

			}.bind(this))
			.catch( function(err) {

				if ( err.response.data.error === 'invalid_grant' ) {

					this.responseType = 'error';
					this.response = 'Our connection to this Google Account has expired, please <a href="/account/google/">click here</a> to head over to "Connected Google Accounts" above and reconnect it there.';

				}
				else {

					this.responseType = 'error';
					this.response = err.response.data.error;

				}

				this.loading = "";

			}.bind(this));

		},
		getAnalyticsAccounts (googleAccountId) {

			googleAccountId = googleAccountId ? googleAccountId : this.googleAccount;

			this.loading = "Fetching analytics account info...";

			const projectId = this.projectIds.length > 0 ? ( '/' + this.projectIds[0] ) : '';

			ApiService.get( 'google/analyticsAccounts/' + googleAccountId + projectId )
			.then( function( info ) {

				this.analyticsAccounts[googleAccountId] = info.data;

				this.analyticsAccountsProcessed = this.analyticsAccounts[this.googleAccount] ? this.analyticsAccounts[this.googleAccount] : [];

				if ( this.analyticsAccounts.length === 0 ) {

					// this.saveProject ( this.googleAccount ); removed as need to tweak this as it's needed!!

				}

				this.loading = "";

			}.bind(this))
			.catch( function(err) {

				this.responseType = 'error';

				if ( err.response.data.error === 'invalid_grant' ) {

					this.response = 'Our connection to this Google Account has expired, please click "Connected Google Accounts" above and reconnect it there.';

				}
				else {

					this.complete( 'error', err.response.data.error );

				}

				this.loading = "";

			}.bind(this));

		},

		errorHandler ( type, output ) {

			this.loading = "";
			this.responseType = 'error';

			switch ( type ) {

				case 'popup_closed_by_user' :
				case 'popup_closed' :
				case 'access_denied' :

					this.response = "Something went wrong, did you close the window early?";

				break;

				case 'popup_blocked_by_browser' :
				case 'popup_failed_to_open' :

					this.response = "It looks like the Google popup was blocked by your browser. Please enable popups and try again.";

				break;

				default :

					this.response = "Sorry we are having a problem connecting your Google account, please get in touch.";

					if ( !!output ) {

						console.log( 'Google Connect Error', output );

						ApiService.post( 'google/auth-issue', { output: output } )
						.then( function() {})
						.catch( function() {});

					}

			}

		},

		checkDomain () {

			this.domainsChecked[this.domain] = this.domainsChecked[this.domain] || {};

			if ( !this.googleAccount ) return false;

			if ( typeof this.domainsChecked[this.domain][this.googleAccount] !== 'undefined' ) {

				if ( !this.domainsChecked[this.domain][this.googleAccount] ) {

					this.googleAccount = null;
					this.$snotify.error('This GSC account is already connected to this domain.', 'Google account');
					return false;

				}

				return true;

			}

			this.loading = "One moment...";

			ApiService.post( 'google/check-domain', { domain: this.domain, googleAccountId: this.googleAccount } )
			.then( function( info ) {

				this.domainsChecked[this.domain][this.googleAccount] = true;
				this.getAnalyticsAccounts();

			}.bind(this))
			.catch( function(err) {

				this.domainsChecked[this.domain][this.googleAccount] = false;

				this.googleAccount = null;
				this.loading = "";
				general.$snotify (this, 'error', 'Google account', err);
				return false;

			}.bind(this));

		},
		googleAuth () {

			if ( !this.loaded ) {

				this.loaded = true;
				
			}

			this.response = '';

			if ( this.googleAccount !== null ) {

				this.getAnalyticsAccounts ();

				return;

			}

			let t = this, 
				s = this.projectIds.length > 1 ? 's' : '';

			this.$dialog
				.confirm( 'Please make sure you tick to confirm that RankCaddy can <strong>"View Search Console data for your verified sites"</strong> and <strong>"See and download your Google Analytics data"</strong>, these will not be ticked by default.', { okText: 'OK', cancelText: 'Cancel',})
				.then(async function() {

					t.loading = "Waiting for confirmation back from the Google popup window...";

					t.response = '';
					
					let client = google.accounts.oauth2.initCodeClient({
						client_id: t.clientId,
						scope: t.scope,
						ux_mode: 'popup',
						callback: (authResult) => {
							
							if ( authResult.error ) {
								
								t.errorHandler( authResult.error, authResult );
								return;

							}
							
							let info = { 
								code: authResult.code 
							};

							t.response = '';

							if ( !t.reconnecting ) {

								info.projectIds = t.projectIds;
								info.domain = t.domain;

							}
							else {

								info.reconnectId = t.reconnectId;

							}
							
							ApiService.post( 'google/token', info )
							.then( function( info ) {

								if ( !t.reconnecting ) {

									t.analyticsAccounts[info.data.googleAccount] = info.data.items;
									t.googleAccountsList = info.data.googleAccounts;
									t.googleAccount = info.data.googleAccount;

									t.complete( 'success', null, { googleAccount: t.googleAccount, googleAccountsList: t.googleAccountsList } );

								}
								else {

									t.complete( 'success', null, {} );

								}

								t.gscDone = true;
								t.loading = "";

							})
							.catch( function(err) {

								t.responseType = 'error';
								t.response = err.response.data.error;

								if ( err.response.data.generic ) {

									t.response = "There was an error connecting your account, please click the message icon on the bottom right of the screen to get in touch with us.";

								}

								t.loading = "";

							});

						},
						error_callback (response) {
							
							t.errorHandler( response.type, response );
							
						}
					});

					try {

						client.requestCode();

					}
					catch (err) {

						console.log(err);

					}

				}.bind(this))
				.catch(function(err) {

					t.loading = "";

					t.response = '';

				}.bind(this));
				
		},
		saveProject () {

			let s = this.projectIds.length > 1 ? 's' : '';

			this.loading = "One moment...";

			ApiService.put( 'projects', { _ids: this.projectIds, googleAccount: this.googleAccount, updateType: 'dataDive' } )
			.then( function( info ) {

				this.complete('success',"Your Google account has been added");
				this.loading = "";

			}.bind(this))
			.catch( function(err) {

				this.complete('error',err.response.data.error);
				this.loading = "";
			
			}.bind(this));

		}

	},
	created() {

		ApiService.get( 'google/accounts' )
		.then( function( info ) {

			this.googleAccountsList = info.data;

		}.bind(this))
		.catch( function(err) {}.bind(this));

	},
	mounted () {

		let scriptId = 'google-gsi',
			apiUrl = 'https://accounts.google.com/gsi/client',
			t = this;

		if ( !document.getElementById(scriptId) ) {

			let script = document.createElement('script');
			script.src = apiUrl;
			script.id = scriptId;
			script.onreadystatechange = script.onload = function () {
				if (!script.readyState || /loaded|complete/.test(script.readyState)) {
					setTimeout(function () {
						
					}, 500)
				}
			}
			document.getElementsByTagName('head')[0].appendChild(script)

		}

	},
	beforeDestroy() {

  		

  }
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_settings.less';
.google-connect {

	text-align: center;
	background-color: #fff;
	border-radius: 5px;
	max-width: 700px;
	margin: 0 auto;
	padding: 0 30px 30px;
	position: relative;

	&.reconnecting {

		padding-top: 30px;
		max-width: 500px;

	}

	p {

		padding: 0;
		margin: 0 0 20px;

		&.statement {

			color: #757575;
			font-size: 12px;
			text-align: center;
			margin: 15px 0 0;

			span {
				color: inherit;
			}

		}

	}

	.connect-issue {

		color: @formDefaultColour;

	}

	.response {

		background-color: @formDefaultColour;
		color: #fff;
		padding: 10px;
		border-radius: 6px;

		&.error {

			background-color: @red;

		}

	}

	.v-select {

		margin: 0 0 10px;

	}

	.large-button {

		margin-top: 0;

	}

	.google-btn {

		.label, svg {

			display: inline-block;
			vertical-align: text-top;

		}

		.label {

			padding: 2px 10px 6px 0;

		}

		.google-btn-wrap {

			display: inline-block;
			-webkit-box-shadow: 1px 1px 7px -4px #757575;
			-moz-box-shadow:1px 1px 7px -4px #757575;
			box-shadow: 1px 1px 7px -4px #757575;
			border-radius: 5px;
			height: 49px;
			cursor: pointer;
			padding: 0 0 0 2px;

			.label {

				color: #757575;
				font-weight: @bold;
				padding: 13px 12px 0 2px;

			}

			&:hover {

				background-color: #4285f4;

				.label {

					color: #fff;

				}

			}

		}

	}

	.addGSC {

		width: auto;
		display: inline-block;
		padding:15px 10px 20px;
		border-radius: 10px;
		vertical-align: top;
		position: relative;

		svg {
			display: block;
			width: 100%;
    		max-width: 220px;
		}

		&:hover {
			border-color: rgba(0, 0, 0, 1);
		}

		&.done {

			&:after {
				content: "✓ Search Console account added";
				color: #37b74a;
				font-size: 14px;
				position: absolute;
				display: block;
				right: -171px;
				font-weight: @bold;
				top: 8%;
			}

			&.confirmUnder {

				padding-bottom: 60px;

				&:after {
					top: 80px;
					width: 100%;
					text-align: center;
					right: auto;
				}

			}

		}

	}

	&.reconnecting {

		padding-top: 0;

		.addGSC {

			&.done {

				&:after {

					content: "✓ Google account reconnected";

				}

			}

		}

	}

}
@media screen and (min-width: 768px) {

	.google-connect {

		&:not(.reconnecting) {

			.select-wraps {

				display: flex;

				.select-wrap {

					flex: 1;
					margin: 0 10px 0 0;

					&:last-child {

						margin: 0;

					}

				}

			}

		}

	}

}
</style>